/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from './../useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Train Icon component.
 */
export const AssetTrainIcon = (props: IconProps) => {
  const {color, size = IconSize.large} = props;
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d="M8.70459 10.8555C9.69069 10.8555 10.6282 11.2867 11.269 12.0361L13.7427 14.9316L3.63916 14.9404V10.8555H8.70459ZM16.1753 7.16406C16.4712 7.16441 16.7611 7.25776 17.0103 7.43359C17.2593 7.60939 17.4568 7.86046 17.5806 8.15625L20.4038 12.8838C20.4866 13.0814 20.5281 13.297 20.5259 13.5146C20.5236 13.7324 20.477 13.947 20.3901 14.1426C20.3032 14.3381 20.1777 14.51 20.0229 14.6455C19.8682 14.781 19.6882 14.8775 19.4956 14.9268L14.8208 14.9307L11.8921 11.5039C11.0955 10.5722 9.93042 10.0361 8.70459 10.0361H3.63916V7.16406H16.1753Z" fill={iconColor}/>
      <rect x="3.47412" y="15.8242" width="15.9923" height="1.01156" fill={iconColor}/>
    </svg>
  );
};

export default AssetTrainIcon;
